import { SignInPage as BackstageSignInPage } from '@backstage/core-components';
import { configApiRef, useApi } from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { GoogleSignInPage } from './GoogleSignInPage';

// Login Google só existe em produção (auth.providers.google no
// app-config.production.yaml). Em dev, sem esse bloco de config, cai no
// guest provider — não trava o boot local (branch intacto, sem redesign).
export const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const configApi = useApi(configApiRef);
      const googleConfigured = Boolean(
        configApi.getOptionalConfig('auth.providers.google'),
      );

      if (!googleConfigured) {
        return <BackstageSignInPage {...props} providers={['guest']} />;
      }

      return <GoogleSignInPage {...props} />;
    },
  },
});
